import * as React from 'react'
import { FC } from 'react'
import { TextField, useRecordContext } from 'react-admin'

interface IDFieldProps {
  label?: string
}

const IDField: FC<IDFieldProps> = () => {
  const record = useRecordContext()
  if (!record || !record.id) return null

  const id = record.id.split('-')[0]
  return <TextField record={{ id }} source="id" />
}

export default IDField
